module.exports = __webpack_public_path__ + "img/rw_logo_comm.b82538e5dc5115a2fb8e7b1073348f39.svg";